import CardHeader from "./common/CardHeader";

const statCardClasses =
    "flex flex-col p-4 gap-4 rounded-lg bg-surface-alt";

const statListClasses = "flex flex-col gap-2";

const statRowClasses =
    "grid grid-cols-[140px_1fr_20px] items-center gap-1.5 h-9";

const labelClasses =
    "overflow-hidden text-content text-right text-ellipsis whitespace-nowrap " +
    "font-heading text-xs not-italic font-normal leading-5";

const barWrapperClasses = "relative h-9";

const barClasses = "h-full rounded";

const valueClasses =
    "absolute top-1/2 [transform:translateY(-50%)] text-[calc(var(--spacing)*3.25)] " +
    "font-medium whitespace-nowrap text-content";

const BarStatCard = ({ title, icon, data, colors, cardIndex, rightContent = '', limit = 5, onClick }) => {
    const maxValue = Math.max(...data.map(d => d.value));
    const subscriptionData = data.map((item, index) => ({
        ...item,
        color: colors[(index + cardIndex) % colors.length],
    }));

    // make the card clickable when an onClick handler is provided
    const isClickable = typeof onClick === 'function';
    const interactionClasses = isClickable ? ' cursor-pointer hover:shadow-md transition-shadow' : '';
    const handleKeyDown = (e) => {
        if (!isClickable) return;
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick(e);
        }
    };

    return (
        <div
            className={`${statCardClasses}${interactionClasses}`}
            onClick={isClickable ? onClick : undefined}
            onKeyDown={isClickable ? handleKeyDown : undefined}
            role={isClickable ? 'button' : undefined}
            tabIndex={isClickable ? 0 : undefined}
        >
            <CardHeader
                title={title}
                icon={icon}
                rightContent={rightContent}
            />
            <div className={statListClasses}>
                {subscriptionData
                    ?.sort((a, b) => b.value - a.value)
                    ?.slice(0, limit)?.map((item, index) => {
                        let width = (item.value / (maxValue || 1)) * 100;
                        width = Math.min(width, 85);
                        return (
                            <div key={index} className={statRowClasses}>
                                <span className={`${labelClasses} text-left!`}>{item.companyName}</span>

                                <div className={barWrapperClasses}>
                                    <div
                                        className={barClasses}
                                        style={{
                                            width: `${width}%`,
                                            backgroundColor: item?.color,
                                        }}
                                    />
                                    <span
                                        className={valueClasses}
                                        style={{ left: `calc(${width}% + 8px)` }}
                                    >
                                        {item.value}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};

export default BarStatCard;
